import { tokens } from '@arvoreeducacao/bonsai-ds'
import type { Settings } from 'react-slick'

export const titleOptions = {
  desktop: 'Livros nivelados',
  mobile: 'Explore livros por nível'
} as const

export const buttonTextOptions = {
  desktop: 'Conheça essas classificações',
  mobile: ''
} as const

export const CEFR_TITLE = 'De acordo com o CEFR:' as const
export const FOUNTAS_PINNEL_TITLE = 'Nivelamento de A-Z:' as const

export const CEFR = 'CEFR' as const
export const FOUNTAS_AND_PINNELL = 'FOUNTAS_AND_PINNELL' as const

export const carouselEnglishLevelSettings = ({ isCEFR = false }): Settings => {
  return {
    lazyLoad: 'ondemand',
    variableWidth: true,
    slidesToScroll: isCEFR ? 5 : 13,
    slidesToShow: isCEFR ? 6 : 13,
    speed: 500,
    infinite: false,
    responsive: [
      {
        breakpoint: tokens.sizes.xxlgScreen,
        settings: {
          slidesToScroll: isCEFR ? 6 : 12,
          slidesToShow: isCEFR ? 5 : 12
        }
      },
      {
        breakpoint: tokens.sizes.xlgScreen,
        settings: {
          slidesToScroll: isCEFR ? 4 : 10,
          slidesToShow: isCEFR ? 4 : 10
        }
      },
      {
        breakpoint: tokens.sizes.lgScreen,
        settings: {
          slidesToScroll: isCEFR ? 3 : 6,
          slidesToShow: isCEFR ? 3 : 6
        }
      },
      {
        breakpoint: tokens.sizes.mdScreen,
        settings: {
          slidesToScroll: isCEFR ? 2 : 5,
          slidesToShow: isCEFR ? 2 : 5
        }
      },
      {
        breakpoint: tokens.sizes.smScreen,
        settings: {
          slidesToScroll: isCEFR ? 2 : 3,
          slidesToShow: isCEFR ? 2 : 3
        }
      }
    ]
  }
}
